//Sets activityFilter state to value of selected option
export const filterAthlete = (e, setAthleteFilter) => {
    setAthleteFilter(e.target.value)
}